import React from "react";
import HierarchicalRefinementList from "components/search/base/HierarchicalRefinementList";
import typeCategories from "components/search/references/typeCategories";

const TypeHierarchicalRefinementList = () => {
  return (
    <HierarchicalRefinementList
      attribute="type"
      categories={typeCategories}
      limit={50}
      title="Type of Work & Genre"
    />
  );
};

export default TypeHierarchicalRefinementList;
